import { effects } from 'redux-saga'

import {
  LOAD_COUPONS,
  LOAD_OFFERS,
  LOAD_PRODUCTS,
} from '../../modules/product'

import load from './load'
import loadCoupons from './loadCoupons'
import loadOffers from './loadOffers'

export default function* product(apis) {
  yield [
    effects.takeEvery(LOAD_COUPONS, loadCoupons, apis),
    effects.takeEvery(LOAD_OFFERS, loadOffers, apis),
    effects.takeEvery(LOAD_PRODUCTS, load, apis),
  ]
}

export const sagas = {
  load,
  loadCoupons,
  loadOffers,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/product/index.js